import { useSelector } from 'react-redux';
import {
    HStack,
    VStack,
    Progress,
    Skeleton,
    SkeletonCircle,
} from '@chakra-ui/react';
import { Card, CardBody } from 'components/v4/Card';
import styles from '../styles';

const DashboardCardSkeleton = () => {
    const { darkMode } = useSelector((state) => state.settings);

    return (
        <Card
            bg={darkMode ? 'dark.tcap' : null}
            sx={{
                ...styles.serviceCard,
                border: '1px solid',
                borderColor: darkMode ? 'gray.700' : 'gray.200',
                boxShadow: darkMode
                    ? 'none'
                    : '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
            }}>
            <Progress
                value={100}
                sx={styles.verticalBar}
                colorScheme="gray"
                isIndeterminate
            />
            <CardBody
                sx={{
                    display: 'flex',
                    flexDir: 'column',
                    ...styles.serviceCardBody,
                }}>
                {/* (3158) Same size as the compact card it stands in for. */}
                <HStack alignItems="flex-start" width="100%" spacing={3}>
                    <SkeletonCircle size="30px" />
                    <VStack alignItems="flex-start" width="100%" spacing={2}>
                        <Skeleton height="18px" width="160px" />
                        <Skeleton height="14px" width="110px" />
                    </VStack>
                </HStack>
            </CardBody>
        </Card>
    );
};

export default DashboardCardSkeleton;
